import React from 'react'

import { Link } from 'gatsby'
import { GatsbyImage } from 'gatsby-plugin-image'
import htmr from 'htmr'
import PropTypes from 'prop-types'
import styled from 'styled-components'

import { colors, space } from '../../style/design-system'
import Card from './Card'

const BlogLinkWBgPicture = ({
  className, description, featuredImg, heading, noNoRegularImageSrc, slug,
}) => (
  <Card className={`p-0 ${className}`}>
    <Link to={slug}>
      {
          featuredImg && (
            <GatsbyImage alt={Array.isArray(heading) ? heading[0] : heading} image={featuredImg.image} />
          )
        }
      {noNoRegularImageSrc && (
      <img alt={Array.isArray(heading) ? heading[0] : heading} src={htmr(noNoRegularImageSrc)} />
      )}
      <h3 className="mt-5">{htmr(heading)}</h3>
      { description && <p>{htmr(description)}</p> }
      <div className="btn btn-outline-black">Read More</div>
    </Link>
  </Card>
)

export default styled(BlogLinkWBgPicture)`

  box-shadow: 0 0 1px ${colors.dev.gray.a(0.5)}, 0 4px 8px ${colors.dev.gray.a(0.1)};

  a {
    border: 1px solid transparent;
    border-radius: 2px;
    color: ${colors.dev.blue.d()};
    display: block;
    overflow: hidden;
    padding: ${space.c};
    position: relative;
    transition: all 0.2s ease-in-out;
    width: 100%;

    &:active,
    &:focus,
    &:hover {
      border: 1px solid ${colors.dev.gray.g()};
      text-decoration: none;

      .btn {
        background-color: ${colors.dev.gray.b()};
        color: #fff;
      }
    }

    img {
      width: 100%;
    }

    .btn {
      font-size: 1rem;
      padding: ${space.c} ${space.d};
    }
  }

`

BlogLinkWBgPicture.propTypes = {
  className: PropTypes.string,
  description: PropTypes.string,
  featuredImg: PropTypes.object,
  heading: PropTypes.string,
  noNoRegularImageSrc: PropTypes.string,
  slug: PropTypes.string.isRequired,
}

BlogLinkWBgPicture.defaultProps = {
  className: '',
  description: '',
  featuredImg: {},
  heading: '',
  noNoRegularImageSrc: '',
}
